var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq35(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.874219,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1105,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.698,
    y1: 12.1824,
    x2: 49.9343,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.0242,
    y1: 49.8543,
    x2: 12.2605,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.4602,
    y1: 38.6199,
    x2: 49.6965,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.786351,
    y1: 0.944118,
    x2: 12.0227,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.868 22.524C17.9333 21.6747 18.26 21.0073 18.848 20.522C19.4453 20.0273 20.2153 19.78 21.158 19.78C21.7833 19.78 22.32 19.892 22.768 20.116C23.216 20.34 23.552 20.648 23.776 21.04C24.0093 21.4227 24.126 21.8567 24.126 22.342C24.126 22.93 23.9533 23.4387 23.608 23.868C23.2627 24.2973 22.7727 24.5633 22.138 24.666V24.736C22.8007 24.8667 23.328 25.156 23.72 25.604C24.112 26.0427 24.308 26.6213 24.308 27.34C24.308 28.1427 24.0373 28.8007 23.496 29.314C22.964 29.818 22.1893 30.07 21.172 30.07C20.2013 30.07 19.4033 29.818 18.778 29.314C18.1527 28.8007 17.7933 28.0773 17.7 27.144H18.652C18.736 27.7693 18.9973 28.278 19.436 28.67C19.8747 29.0527 20.4533 29.244 21.172 29.244C21.8813 29.244 22.4227 29.0573 22.796 28.684C23.1787 28.3107 23.37 27.8347 23.37 27.256C23.37 25.8373 22.348 25.128 20.304 25.128H19.996V24.302H20.318C22.222 24.302 23.174 23.6813 23.174 22.44C23.174 21.8987 22.9967 21.4647 22.642 21.138C22.2873 20.802 21.7833 20.634 21.13 20.634C20.4953 20.634 19.968 20.802 19.548 21.138C19.1373 21.4647 18.8947 21.9267 18.82 22.524H17.868ZM32.4275 20.802H27.3035V24.386C27.5368 24.0593 27.8775 23.7933 28.3255 23.588C28.7735 23.3733 29.2588 23.266 29.7815 23.266C30.5468 23.266 31.1721 23.4247 31.6575 23.742C32.1428 24.05 32.4928 24.456 32.7075 24.96C32.9221 25.4547 33.0295 25.9867 33.0295 26.556C33.0295 27.2093 32.9035 27.802 32.6515 28.334C32.4088 28.8567 32.0308 29.272 31.5175 29.58C31.0135 29.888 30.3835 30.042 29.6275 30.042C28.6661 30.042 27.8868 29.7947 27.2895 29.3C26.6921 28.796 26.3281 28.1193 26.1975 27.27H27.1635C27.2848 27.886 27.5648 28.362 28.0035 28.698C28.4421 29.034 28.9835 29.202 29.6275 29.202C30.4395 29.202 31.0508 28.964 31.4615 28.488C31.8815 28.0027 32.0915 27.3633 32.0915 26.57C32.0915 25.7953 31.8815 25.1933 31.4615 24.764C31.0415 24.3253 30.4395 24.106 29.6555 24.106C29.1141 24.106 28.6381 24.232 28.2275 24.484C27.8168 24.736 27.5135 25.0767 27.3175 25.506H26.3935V19.948H32.4275V20.802Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq35);
export default __webpack_public_path__ + "static/media/fq35.13d8ee10f3b8bc089db4f676273c5001.svg";
export { ForwardRef as ReactComponent };